module.exports = __webpack_public_path__ + "static/media/about-bg.6cc99696.jpg";